// import { Observable } from 'rxjs';
import { NgRedux, select } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import * as Store from '@core/redux/stores';
import { IAppState } from '@core/redux/stores';
import * as _ from 'lodash-es';
import { Observable, Subscription } from 'rxjs';

@Injectable()
export class ContactUsCheckGuard implements CanActivate {

  private subscriptions = new Subscription();

  @select((appState) => appState.contactUs) contactUsObject?: Observable<Store.ContactUs>;

  public contactDetailsData: Store.ContactUs;

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {

    if ((this.contactDetailsData && Object.entries(this.contactDetailsData).length === 0) || !this.contactDetailsData) {
      // this.continued = true;
      // this.router.navigateByUrl('/contact-us');
      this.router.navigateByUrl('/contact-us');
      return false;
    } else if (this.router.url.indexOf('thanks') !== -1) {
      this.router.navigateByUrl('/contact-us');
      return false;
    }

    return true;
    // return new Observable<boolean>(observer => {
    //   observer.next(true);
    //   observer.complete();
    // });

  }

  constructor(private ngRedux: NgRedux<IAppState>, private router: Router) {

    this.subscriptions.add(
      this.contactUsObject.subscribe(
        (Succ) => {
          if (Succ) {
            this.contactDetailsData = _.cloneDeep(Succ) as Store.ContactUs;
          } else {
            // this.contactDetailsData.visitInfo = new Store.VisitInfo;
          }
      }
      )
    );

  }

  // ngOnDestroy() {
  //   this.subscriptions.unsubscribe();
  // }
}
